import { z } from "zod";

const creditOptionSchema = z.object({
  amount: z.number(),
  disabled: z.boolean(),
  disabledReason: z.string().nullable(),
});

export const creditSchema = z.object({
  pending: z.number(),
  available: z.number(),
  queued: z.number(),
  options: z.array(creditOptionSchema),
  hasReachedMonthlyLimit: z.boolean(),
});
